import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils";

export type User = {
  id: string;
  email: string;
  userType: "patient";
  lastLogin?: string;
  givenName: string;
  familyName: string;
};

export const userSchema: Schema<User> = cz.transform(
  z.object({
    id: z.string(),
    email: z.string(),
    user_type: z.literal("patient"),
    last_login: cz.optional(z.string()),
    first_name: z.string(),
    last_name: z.string(),
  }),
  data => ({
    id: data.id,
    email: data.email,
    userType: data.user_type,
    lastLogin: data.last_login,
    givenName: data.first_name,
    familyName: data.last_name,
  }),
);
